import { EntityName as SharedEntityName } from 'src/types/EntityName';
import { EntityName } from 'src/components/DataTable/types/DataTableSelection';
import { getSingularOrPlural } from 'src/utilities/getSingularOrPlural';
import { getEntityNameByCount } from 'src/utilities/getEntityNameByCount';

export function resolveEntityName(entityName: EntityName): SharedEntityName {
  if (typeof entityName === 'string') {
    return {
      singular: entityName,
      plural: getSingularOrPlural(2, entityName),
    };
  }

  return {
    singular: entityName.singular,
    plural: entityName.plural ?? getSingularOrPlural(2, entityName.singular),
  };
}

export function getSelectionCountText(
  count: number,
  entityName: EntityName = 'item'
): string {
  const resolvedEntityName = resolveEntityName(entityName);
  const entityDisplay = getEntityNameByCount(count, resolvedEntityName);

  return `${count} ${entityDisplay} selected`;
}
